import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import employers from './modules/employers';
import contacts from './modules/contacts';
import contractors from './modules/contractors';
import companies from './modules/companies';
import tasks from './modules/tasks';
import deals from './modules/deals';
import leads from './modules/leads';
import events from './modules/events';
import cash from './modules/cash';
import rights from './modules/rights';
import references from './modules/references';
import preferences from './modules/preferences';
import metrics from './modules/metrics';
import timesheet from './modules/timesheet';
import voip from './modules/voip';
import calendar from './modules/calendar';
import map from './modules/map';
import logs from './modules/logs';
import analytics from './modules/analytics';
import search from './modules/search';
import incomes from './modules/incomes';
import expenses from './modules/expenses';
import debts from './modules/debts';
import salary from './modules/salary';
import registryEmployers from './modules/registry-employers';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        auth,
        employers,
        contacts,
        contractors,
        companies,
        tasks,
        deals,
        leads,
        rights,
        events,
        references,
        cash,
        preferences,
        metrics,
        timesheet,
        calendar,
        map,
        voip,
        logs,
        analytics,
        search,
        incomes,
        expenses,
        debts,
        salary,
        registryEmployers
    },
    strict: debug
});
